import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-white/10 px-6 pb-10 pt-20 md:px-12" data-testid="footer">
    <div className="mx-auto max-w-[1600px]">
      <div className="flex flex-col justify-between gap-12 md:flex-row md:items-end">
        <div>
          <div className="font-display text-5xl font-black uppercase tracking-tighter md:text-7xl">
            PP<span className="text-brand">.</span>Academy
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-zinc-500">
            Engineering · Trading · School 1–12 · MBA Finance. Any textbook, any board, English medium.
          </p>
        </div>
        <div className="flex gap-16 text-sm">
          <div className="flex flex-col gap-3">
            <span className="text-xs uppercase tracking-widest text-zinc-600">Learn</span>
            <a href="#courses" data-testid="footer-courses-link" className="link-underline text-zinc-400 hover:text-white">Courses</a>
            <Link to="/live" data-testid="footer-live-link" className="link-underline text-zinc-400 hover:text-white">Live Classes</Link>
            <a href="#mentor" data-testid="footer-mentor-link" className="link-underline text-zinc-400 hover:text-white">The Mentor</a>
            <a href="#contact" data-testid="footer-contact-link" className="link-underline text-zinc-400 hover:text-white">Contact</a>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-xs uppercase tracking-widest text-zinc-600">Academy</span>
            <Link to="/admin" data-testid="footer-admin-link" className="link-underline text-zinc-400 hover:text-white">Admin</Link>
            <span className="text-zinc-500">hello@ppacedemy.in</span>
          </div>
        </div>
      </div>
      <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-xs text-zinc-600 md:flex-row">
        <span>© {new Date().getFullYear()} PP Academy — ppacedemy.in. All rights reserved.</span>
        <span className="font-editorial italic">Learn. Build. Trade.</span>
      </div>
    </div>
  </footer>
);
